var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"supplier","instance-name":"Supplier","create":d => _vm.suppliers.create(d),"delete":d => _vm.suppliers.remove(d),"update":d => _vm.suppliers.update(d),"get":d => _vm.suppliers.get(d),"upsert":_vm.upsert,"details":_vm.details,"columns":_vm.columns,"hideDelete":!_vm.isCommonAdmin}})
}
var staticRenderFns = []

export { render, staticRenderFns }